.bb{max-width:100%;}